export function VehicleCtrl (
  $rootScope,
  $state,
  $scope,
  $translate,
  attachments,
  blockUI,
  carfaxApi,
  company,
  confirm,
  customer,
  events,
  history,
  inheritorApi,
  inspections,
  inspectionStatuses,
  invoices,
  messages,
  transactions,
  vehicle,
  vehicleGroups,
  vehicleRegistrationApi,
  xeroApi
) {
  $scope.attachments              = attachments;
  $scope.block                    = blockUI.instances.get('vehicleBlock');
  $scope.carfaxStatus             = '';
  $scope.company                  = company;
  $scope.customer                 = customer;
  $scope.events                   = events;
  $scope.history                  = history;
  $scope.inspections              = inspections;
  $scope.inspectionStatuses       = inspectionStatuses;
  $scope.invoices                 = invoices;
  $scope.transactions             = transactions;
  $scope.vehicle_body_group_types = vehicleGroups;

  $scope.vehicle = vehicle || {
    air_conditioner : true,
    body_type       : 'SEDAN',
    customer_id     : $scope.customer.id,
    cylinders       : 0,
    horse_power     : 0,
    odometer        : 0,
    plate_state     : $scope.customer.state || $scope.company.state,
    seating_capacity: 0,
    transmission    : 'N/A',
    vehicle_group   : $scope.vehicle_body_group_types[0].code
  };

  $scope.attachmentOptions = {
    contact: {
      email: $scope.customer.email,
      phone: $scope.customer.mobile || $scope.customer.phone
    },
    description: $translate.instant('DEALERSHIP_SPACE.VEHICLE_ATTACHMENT'),
    entity     : $scope.vehicle,
    id_key     : 'vehicle_id',
    open       : $scope.attachments.length,
    table      : 'vehicle',
    routes     : {
      create: '/vehicle/attach_photo',
      delete: '/vehicle_attachment',
      get   : 'vehicle_attachments/for_vehicle',
      show  : 'vehicle_attachment'
    }
  };

  inheritorApi.inheritCtrl('VehicleLiteCtrl', $scope);

  $scope.carfaxHistory = function() {
    carfaxApi.findHistory($scope.vehicle)
    .then(() => {
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.getCarfaxStatus = function () {
    carfaxApi.getStatus($scope.vehicle)
    .then(status => {
      $scope.carfaxStatus = status;
    });
  };

  $scope.viewTireDetails = function () {
    vehicleRegistrationApi.viewTireDetails($scope.vehicle);
  };

  $scope.hasVehicleRegistrationId = function () {
    return vehicleRegistrationApi.hasRegistrationId($scope.vehicle);
  };

  $scope.searchRegistration = function () {
    $scope.block.start();

    vehicleRegistrationApi.search($scope.vehicle)
    .then(vehicle => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.VEHICLE_DETAILS_ACQUIRED'), 'success');

      $scope.vehicle = vehicle;
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.setTrackingCategory = function () {
    this.vehicle.xero_tracking_category_id = this.trackingCategory.tracking_category_id;
  };

  $scope.signupCarfax = function () {
    carfaxApi.getSignupMessage($scope.vehicle)
    .then(message => confirm.generic(message))
    .then(() => carfaxApi.signup($scope.vehicle))
    .then(result => {
      messages.show(result.message, result.type);

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  if ($rootScope.Company.hasIntegration('carfax')) {
    $scope.getCarfaxStatus();
  }

  if ($rootScope.Company.areTrackingCategoryOptionsAvailable()) {
    xeroApi.getTrackingCategoryWithOptions()
    .then(trackingCategory => {
      $scope.trackingCategory        = trackingCategory;
      $scope.trackingCategoryOptions = trackingCategory.options;
    })
    .catch(err => {
      messages.error(err);
    });
  }
};